// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseTypeModels {
    static getAttributeTypeMap() {
        return CaseTypeModels.attributeTypeMap;
    }
}
CaseTypeModels.discriminator = undefined;
CaseTypeModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<CaseTypeModel>"
    }
];
//# sourceMappingURL=caseTypeModels.js.map